export default "__VITE_ASSET__DXn7aRaT__"